/** API base: `VITE_API_URL` (empty means same origin) + `/api/v1`. */
export const API_ORIGIN = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, "");
export const API_BASE = `${API_ORIGIN}/api/v1`;
